export const T = {
  pt: {
    locale: "pt-PT",
    heroStory: "Conheça a minha história",
    nav: { profile: "Perfil", areas: "Áreas", story: "A Minha História", guide: "Guia", contact: "Contacto", book: "Marcar consulta" },
    common: {
      explore: "Saber mais",
      whatsapp: "WhatsApp",
      book: "Marcar consulta",
      backHome: "Voltar ao início",
      viewGuide: "Pedir o guia",
    },
    profile: {
      overline: "Perfil",
      heading: "Uma advogada dedicada às famílias.",
      p1: "Com escritório no coração do Funchal, Maria João Nepomuceno dedica a sua prática ao Direito da Família e das Crianças, acompanhando cada cliente com discrição, rigor técnico e profunda humanidade.",
      p2: "Do divórcio à regulação das responsabilidades parentais, das pensões de alimentos às famílias com ligações a outros países, o acompanhamento é sempre próximo — presencial ou à distância, em português ou em inglês.",
      credentialLabel: "Ordem dos Advogados",
      locationLabel: "Escritório",
    },
    areas: {
      overline: "Áreas de Prática",
      heading: "Aconselhamento focado, não disperso.",
      note: "Três áreas onde a experiência faz a diferença.",
    },
    works: {
      overline: "Como trabalho",
      heading: "Um método claro, do primeiro contacto à resolução.",
      steps: [
        { num: "01", title: "Primeiro contacto", desc: "Uma conversa inicial, por WhatsApp, telefone ou email, para compreender a sua situação sem compromisso." },
        { num: "02", title: "Análise e estratégia", desc: "Estudo do caso e definição de uma estratégia jurídica clara, com expectativas realistas e transparentes." },
        { num: "03", title: "Acompanhamento", desc: "Representação e acompanhamento próximo, presencial no Funchal ou por consulta à distância, onde estiver." },
        { num: "04", title: "Resolução", desc: "Procura da solução mais adequada e humana, sempre no superior interesse das crianças e da família." },
      ],
    },
    legacy: {
      overline: "Uma Família de Juristas",
      heading: "Um legado de Direito com raízes profundas na Madeira.",
      p1: "Maria João é filha do saudoso Comendador Rui Nepomuceno — advogado, político e historiador madeirense, figura maior da vida pública e cultural da Madeira, cujo exemplo e obra continuam a inspirar a sua prática.",
      p2: "Na família Nepomuceno, o Direito atravessa gerações: a sua irmã, Filipa Nepomuceno, cumpre atualmente o seu segundo mandato como Presidente do Conselho Deontológico da Ordem dos Advogados da Madeira.",
      captionFather: "Maria João com o pai, Comendador Rui Nepomuceno",
      captionFamily: "A Tomada de Posse do segundo mandato de Filipa Nepomuceno",
      more: "Conhecer o legado",
    },
    reviews: {
      overline: "Testemunhos",
      heading: "O que dizem os clientes",
      rating: "★ 4,7 · 27 avaliações no Google",
      note: "Avaliações reais de clientes, publicadas no Google.",
    },
    story: {
      metaTitle: "A Minha História — Maria João Nepomuceno, Advogada de Família",
      metaDesc: "Mais de 30 anos de advocacia dedicados ao Direito da Família. A história de Maria João Nepomuceno, filha do Dr. Rui Nepomuceno, e a sua visão sobre a proteção das crianças.",
      overline: "A Minha História",
      h1: "A Minha História",
      intro: "Sou advogada há mais de 30 anos.",
      paras1: [
        "Cresci numa família profundamente ligada ao Direito, acompanhando de perto o percurso do meu pai, o Dr. Rui Nepomuceno, que foi também o meu patrono e a minha maior referência profissional.",
        "Com ele aprendi que a advocacia não se exerce apenas com conhecimento jurídico. Exerce-se com rigor, independência, coragem e, acima de tudo, com respeito pelas pessoas que nos confiam os momentos mais delicados das suas vidas.",
        "Ao longo do meu percurso, fui encontrando no Direito da Família a área que mais me desafia e com a qual mais me identifico. Talvez por ser mãe. Talvez porque nunca consegui aceitar a facilidade com que a sociedade julga uma mãe ou um pai, esquecendo que não existem progenitores perfeitos.",
        "Por vezes, não existe falta de amor. Existem dificuldades, fragilidades e ausência das condições necessárias para cuidar. E existem crianças que precisam de ser verdadeiramente vistas, escutadas e protegidas.",
      ],
      quote1: "São elas o centro do meu trabalho.",
      paras2: [
        "A experiência ensinou-me que, em Direito da Família, não existem fórmulas universais nem soluções que possam ser aplicadas automaticamente. Cada criança tem a sua história. Cada família possui as suas circunstâncias. E cada decisão deve ser pensada de acordo com a idade, os vínculos afetivos, as rotinas, a estabilidade emocional e as necessidades concretas daquela criança.",
        "Durante muitos anos, defendi firmemente a residência alternada. Continuo a considerá-la uma solução positiva quando ambos os progenitores estiveram verdadeiramente presentes na vida dos filhos, partilham os cuidados, conseguem comunicar com respeito e mantêm projetos educativos compatíveis.",
        "Mas a experiência também me mostrou que este regime não serve todas as famílias.",
      ],
      quote2: "Uma criança não é uma mala que se transporta semanalmente entre duas casas.",
      paras3: [
        "Quando existem conflitos permanentes, estilos de vida profundamente diferentes ou incapacidade de cooperação, aquilo que deveria representar equilíbrio pode transformar-se numa fonte de instabilidade.",
        "Não defendo mães contra pais, nem pais contra mães. Defendo que cada situação seja analisada com profundidade, sem preconceitos e sem automatismos, procurando perceber quem aquela criança é e de que necessita para crescer com segurança.",
        "Acredito igualmente que os progenitores não deveriam enfrentar sozinhos processos tão complexos e emocionalmente exigentes. A regulação e a alteração das responsabilidades parentais não se resumem ao preenchimento de um formulário. Por detrás de cada processo existem afetos, medos, conflitos e decisões capazes de marcar toda uma vida.",
        "É por isso que continuo a exercer a advocacia com o mesmo compromisso: ouvir sem julgar, agir com firmeza e procurar, em cada processo, uma solução juridicamente rigorosa, mas também humana.",
      ],
      closing: "Porque o superior interesse da criança não pode ser apenas uma expressão escrita na lei. Tem de estar verdadeiramente presente em cada decisão.",
      cta: "Marcar uma consulta",
    },
    legadoPage: {
      metaTitle: "Legado — Maria João Nepomuceno, Advogada",
      metaDesc: "Uma família de juristas da Madeira: o Comendador Rui Nepomuceno e as suas filhas, Maria João e Filipa Nepomuceno — em fotografias e memórias.",
      overline: "Uma Família de Juristas",
      h1: "Legado",
      intro: "Memórias de uma família profundamente ligada ao Direito e à vida pública da Madeira — em fotografias e histórias.",
      items: [
        {
          title: "Maria João com o pai, Comendador Rui Nepomuceno",
          desc: "O Dr. Rui Nepomuceno — advogado, político e historiador madeirense — foi o patrono e a maior referência profissional de Maria João. Com ele aprendeu que a advocacia se exerce com rigor, independência, coragem e respeito pelas pessoas.",
        },
        {
          title: "O Comendador Rui Nepomuceno com as filhas, Maria João e Filipa",
          desc: "Na família Nepomuceno, o Direito atravessa gerações: Filipa Nepomuceno cumpre atualmente o seu segundo mandato como Presidente do Conselho Deontológico da Ordem dos Advogados da Madeira.",
        },
        {
          title: "Maria João com a irmã, Filipa Nepomuceno",
          desc: "Entre as duas irmãs, o Direito é — para além de profissão — uma cumplicidade de vida. Filipa Nepomuceno exerce o seu segundo mandato como Presidente do Conselho Deontológico da Ordem dos Advogados da Madeira.",
        },
        {
          title: "A Tomada de Posse do segundo mandato de Filipa Nepomuceno",
          desc: "Maria João com a irmã na mais recente Tomada de Posse de Filipa Nepomuceno como Presidente do Conselho Deontológico da Ordem dos Advogados da Madeira — o segundo mandato consecutivo à frente do órgão.",
        },
        {
          title: "Dra. Maria João Nepomuceno de toga",
          desc: "Na Tomada de Posse da irmã, Maria João vestiu a toga — o mesmo traje com que, há mais de 30 anos, defende famílias nos tribunais da Madeira.",
        },
        {
          title: "Com o Bastonário da Ordem dos Advogados",
          desc: "Maria João com o Bastonário da Ordem dos Advogados, na Tomada de Posse da irmã, Filipa Nepomuceno, no Conselho Regional da Madeira.",
        },
        {
          title: "As irmãs Nepomuceno com o pai, Comendador Rui Nepomuceno",
          desc: "Maria João e Filipa com o seu saudoso pai — o advogado, político e historiador que lhes transmitiu o amor pelo Direito e o dever de servir com integridade.",
        },
      ],
    },
    marquee: ["Direito da Família", "Responsabilidades Parentais", "Divórcio", "Pensões de Alimentos", "Funchal · Madeira"],
    guide: {
      overline: "Guia Gratuito",
      cta: "Receber por email",
      form: {
        name: "Nome",
        email: "Email",
        gdpr: "Autorizo o tratamento dos meus dados para receber o guia e ser contactada(o), nos termos da Política de Privacidade.",
        submit: "Enviar-me o guia",
        sending: "A enviar…",
        success: "Pedido recebido. Verifique o seu email.",
        successNote: "Enquanto a verificação de domínio de email não está ativa, pode transferir o guia diretamente:",
        download: "Transferir o guia",
        error: "Ocorreu um erro. Tente novamente.",
      },
    },
    contact: {
      overline: "Contacto",
      heading: "Vamos falar sobre o seu caso.",
      intro: "Preencha o formulário ou contacte diretamente por WhatsApp. Responderei pessoalmente.",
      fields: { name: "Nome", email: "Email", phone: "Telefone / WhatsApp", lang: "Idioma preferido", subject: "Assunto", message: "Mensagem" },
      langOptions: { pt: "Português", en: "Inglês" },
      gdpr: "Li e aceito a Política de Privacidade e autorizo o tratamento dos meus dados para efeitos de contacto.",
      submit: "Enviar mensagem",
      sending: "A enviar…",
      success: "Mensagem enviada. Obrigada pelo seu contacto.",
      error: "Não foi possível enviar. Tente novamente ou use o WhatsApp.",
      disabledNote: "Nota: o envio de email será ativado após a verificação do domínio. A sua mensagem foi registada.",
      disclaimer: "Esta comunicação não constitui aconselhamento jurídico nem cria relação advogado-cliente até assinatura de contrato de prestação de serviços.",
    },
    footer: {
      tagline: "Direito da Família · Funchal, Madeira",
      legacy: "Filha do Comendador Rui Nepomuceno — advogado, político e historiador da Madeira. Irmã de Filipa Nepomuceno, Presidente do Conselho Deontológico da Ordem dos Advogados da Madeira (2.º mandato).",
      nav: "Navegação",
      contactHeading: "Contacto",
      legal: "Informação legal",
      privacy: "Política de Privacidade",
      rights: "Todos os direitos reservados.",
    },
    pages: {
      consulta: {
        metaTitle: "Responsabilidades Parentais — Maria João Nepomuceno, Advogada",
        metaDesc: "Guarda, residência, convívios e alimentos — tudo o que envolve a vida dos filhos após a separação. Consulta presencial ou online.",
        overline: "Direito das Crianças",
        h1: "Responsabilidades Parentais",
        intro: "O bem-estar dos seus filhos está sempre em primeiro lugar. Acompanho os pais em cada decisão que molda a vida da criança.",
        paras: [
          "As responsabilidades parentais dizem respeito às decisões importantes na vida dos filhos — onde vivem, o tempo que passam com cada progenitor e o seu sustento. Podem ser acordadas entre os pais ou definidas com o apoio do tribunal, sempre no superior interesse da criança.",
          "Quando pais e filhos vivem em locais diferentes, a consulta pode ser feita à distância, com o mesmo cuidado e confidencialidade de um encontro presencial.",
        ],
        bullets: [
          "Guarda e residência dos filhos",
          "Regime de convívios e férias",
          "Pensão de alimentos a filhos",
          "Alteração e incumprimento de acordos",
        ],
        cta: "Marcar uma consulta",
      },
      internacional: {
        metaTitle: "Direito da Família Internacional — Maria João Nepomuceno, Advogada",
        metaDesc: "Apoio a famílias com ligações a mais do que um país, quando o divórcio ou as questões dos filhos atravessam fronteiras.",
        overline: "Famílias sem Fronteiras",
        h1: "Direito da Família Internacional",
        intro: "Cada vez mais famílias vivem entre países. Ajudo a encontrar clareza quando as questões familiares atravessam fronteiras.",
        paras: [
          "Um divórcio ou uma questão sobre os filhos ganha novos contornos quando a família tem ligações a mais do que um país. É importante compreender onde e como cada assunto deve ser tratado.",
          "Acompanho estas situações com sensibilidade e em articulação com profissionais noutros países, sempre com foco na proteção das crianças e na tranquilidade da família.",
        ],
        bullets: [
          "Divórcio e separação com ligação a outros países",
          "Questões dos filhos entre países",
          "Reconhecimento de decisões estrangeiras em Portugal",
          "Coordenação com advogados de outras jurisdições",
        ],
        cta: "Falar sobre a minha situação",
      },
      vistos: {
        metaTitle: "Vistos e Residência em Portugal — Maria João Nepomuceno, Advogada",
        metaDesc: "Acompanhamento jurídico a quem escolhe viver em Portugal e na Madeira, com especial atenção ao reagrupamento da família.",
        overline: "Viver na Madeira",
        h1: "Vistos e Residência",
        intro: "Começar uma nova vida em Portugal deve ser simples e seguro. Acompanho todo o percurso, do pedido à instalação da família.",
        paras: [
          "Quem escolhe viver em Portugal e na Madeira precisa de apoio para tratar do visto e da autorização de residência adequados ao seu caso, bem como de toda a documentação necessária.",
          "Como advogada de família, dou especial atenção ao reagrupamento familiar e a tudo o que envolve trazer a família para junto de si, com segurança e serenidade.",
        ],
        bullets: [
          "Vistos e autorizações de residência",
          "Reagrupamento familiar",
          "Apoio à instalação na Madeira",
          "Acompanhamento próximo em todo o processo",
        ],
        cta: "Iniciar o meu processo",
      },
      divorcio: {
        metaTitle: "Divórcio e Separação — Maria João Nepomuceno, Advogada",
        metaDesc: "Acompanhamento próximo e discreto em divórcios e separações, por mútuo acordo ou litigiosos, no Funchal e online.",
        overline: "Recomeçar com Serenidade",
        h1: "Divórcio e Separação",
        intro: "O fim de um casamento é um dos momentos mais delicados da vida. Acompanho cada passo com discrição, firmeza e humanidade.",
        paras: [
          "Um divórcio pode ser tratado por mútuo acordo — de forma rápida e serena — ou exigir a intervenção do tribunal quando não há entendimento. Em ambos os caminhos, o meu papel é proteger os seus interesses e ajudar a fechar este capítulo com dignidade.",
          "Trato de tudo o que o divórcio envolve: a partilha dos bens, a casa de família e, acima de tudo, a estabilidade dos filhos. Cada família é única, e cada processo merece uma estratégia à sua medida.",
        ],
        bullets: [
          "Divórcio por mútuo acordo",
          "Divórcio sem consentimento do outro cônjuge",
          "Partilha de bens e casa de família",
          "Acordos sobre os filhos no divórcio",
        ],
        cta: "Falar sobre a minha situação",
      },
      alimentos: {
        metaTitle: "Pensões de Alimentos — Maria João Nepomuceno, Advogada",
        metaDesc: "Fixação, alteração e incumprimento de pensões de alimentos a filhos e ex-cônjuges. Soluções justas e adequadas a cada família.",
        overline: "O Sustento de Quem Ama",
        h1: "Pensões de Alimentos",
        intro: "Garantir o sustento dos filhos é um dever e um ato de amor. Ajudo a encontrar valores justos — e a fazê-los cumprir.",
        paras: [
          "A pensão de alimentos assegura que os filhos mantêm as condições de vida que merecem, independentemente da separação dos pais. O valor deve ser justo para quem recebe e comportável para quem paga — e pode ser ajustado quando a vida muda.",
          "Quando a pensão não é paga, existem meios eficazes para a exigir. Acompanho também as pensões entre ex-cônjuges, sempre com rigor e sensibilidade.",
        ],
        bullets: [
          "Fixação da pensão de alimentos",
          "Alteração do valor quando a vida muda",
          "Incumprimento e cobrança de pensões em atraso",
          "Alimentos a filhos maiores e ex-cônjuges",
        ],
        cta: "Marcar uma consulta",
      },
      patrimonio: {
        metaTitle: "União de Facto e Património — Maria João Nepomuceno, Advogada",
        metaDesc: "Proteção jurídica de casais em união de facto e do património da família: casa, bens e acordos de vida em comum.",
        overline: "Proteger o que Construíram",
        h1: "União de Facto e Património",
        intro: "Viver a dois sem casar também constrói património e direitos. Ajudo a proteger o que construíram juntos — e cada um.",
        paras: [
          "A união de facto dá origem a direitos e deveres próprios, muitas vezes desconhecidos dos casais. Da casa comum às contas partilhadas, é importante saber o que pertence a quem e como proteger ambos, durante a vida em comum e se ela terminar.",
          "Apoio também na organização do património da família — partilhas, doações e acordos — para que as decisões de hoje tragam tranquilidade amanhã.",
        ],
        bullets: [
          "Direitos e proteção na união de facto",
          "Partilha de bens no fim da vida em comum",
          "Casa de família e bens em nome de um só",
          "Acordos e organização do património familiar",
        ],
        cta: "Pedir orientação",
      },
    },
    privacy: {
      metaTitle: "Política de Privacidade — Maria João Nepomuceno",
      metaDesc: "Política de privacidade e tratamento de dados pessoais.",
      overline: "RGPD",
      h1: "Política de Privacidade",
      sections: [
        { title: "Responsável pelo tratamento", body: "Maria João Nepomuceno, Advogada (Cédula OA 200-M), com escritório na Rua Ivens 22, 3.º Esq., Funchal. Contacto: mjn.advogada@gmail.com." },
        { title: "Dados recolhidos", body: "Recolhemos os dados que nos fornece através dos formulários de contacto e de pedido do guia: nome, email, telefone e o conteúdo da mensagem. Os pedidos de contacto são tratados por email e não são armazenados numa base de dados. Os pedidos do guia são registados para permitir o envio e o cumprimento de obrigações legais." },
        { title: "Finalidade e fundamento", body: "Os dados são tratados com base no seu consentimento e no interesse legítimo de responder aos seus pedidos, exclusivamente para efeitos de contacto e prestação de informação jurídica." },
        { title: "Conservação", body: "Os dados são conservados apenas pelo tempo necessário às finalidades indicadas ou pelo período exigido por lei." },
        { title: "Os seus direitos", body: "Pode exercer os direitos de acesso, retificação, apagamento, limitação, portabilidade e oposição, contactando mjn.advogada@gmail.com." },
        { title: "Análise de tráfego", body: "Utilizamos uma solução de análise sem cookies (Plausible), que não recolhe dados pessoais nem utiliza identificadores de rastreio." },
      ],
    },
    admin: {
      title: "Consola",
      subtitle: "Gestão de conteúdos e pedidos",
      email: "Email",
      password: "Palavra-passe",
      login: "Entrar",
      logout: "Sair",
      loginError: "Credenciais inválidas.",
      tabs: { content: "Conteúdo", leads: "Pedidos do Guia", messages: "Mensagens", pdf: "PDF do Guia" },
      noMessages: "Ainda não há mensagens.",
      messagesCount: "mensagens",
      save: "Guardar alterações",
      saved: "Alterações guardadas.",
      heroTitle: "Hero (linhas do título)",
      heroSub: "Subtítulo",
      overline: "Sobretítulo",
      areasTitle: "Áreas de Prática",
      guideTitle: "Metadados do Guia",
      leadsCount: "pedidos",
      exportCsv: "Exportar CSV",
      uploadPdf: "Substituir PDF do Guia",
      upload: "Carregar",
      uploaded: "PDF atualizado.",
      noLeads: "Ainda não há pedidos.",
    },
  },

  en: {
    locale: "en",
    heroStory: "Discover my story",
    nav: { profile: "Profile", areas: "Practice", story: "My Story", guide: "Guide", contact: "Contact", book: "Book consultation" },
    common: {
      explore: "Learn more",
      whatsapp: "WhatsApp",
      book: "Book consultation",
      backHome: "Back to home",
      viewGuide: "Request the guide",
    },
    profile: {
      overline: "Profile",
      heading: "A lawyer devoted to families.",
      p1: "From her office in the heart of Funchal, Maria João Nepomuceno dedicates her practice to Family and Children's Law, guiding each client with discretion, technical rigour and deep humanity.",
      p2: "From divorce to parental responsibilities, from maintenance to families with ties to other countries, the support is always close — in person or remotely, in Portuguese or English.",
      credentialLabel: "Bar Association",
      locationLabel: "Office",
    },
    areas: {
      overline: "Practice Areas",
      heading: "Focused counsel, never scattered.",
      note: "Three areas where experience makes the difference.",
    },
    works: {
      overline: "How I work",
      heading: "A clear method, from first contact to resolution.",
      steps: [
        { num: "01", title: "First contact", desc: "An initial conversation — by WhatsApp, phone or email — to understand your situation with no obligation." },
        { num: "02", title: "Analysis & strategy", desc: "Studying the case and defining a clear legal strategy, with realistic and transparent expectations." },
        { num: "03", title: "Ongoing support", desc: "Representation and close support, in person in Funchal or by remote consultation, wherever you are." },
        { num: "04", title: "Resolution", desc: "Pursuing the most suitable and humane solution, always in the best interest of the children and the family." },
      ],
    },
    legacy: {
      overline: "A Family of Jurists",
      heading: "A legacy of Law with deep roots in Madeira.",
      p1: "Maria João is the daughter of the late Comendador Rui Nepomuceno — a renowned Madeiran lawyer, politician and historian, a leading figure in Madeira's public and cultural life, whose example and work continue to inspire her practice.",
      p2: "In the Nepomuceno family, Law spans generations: her sister, Filipa Nepomuceno, is currently serving her second term as President of the Deontology Council of the Madeira Bar Association (Ordem dos Advogados).",
      captionFather: "Maria João with her father, Comendador Rui Nepomuceno",
      captionFamily: "The swearing-in of Filipa Nepomuceno's second term",
      more: "Discover the legacy",
    },
    reviews: {
      overline: "Testimonials",
      heading: "What clients say",
      rating: "★ 4.7 · 27 Google reviews",
      note: "Real client reviews, published on Google (original text in Portuguese).",
    },
    story: {
      metaTitle: "My Story — Maria João Nepomuceno, Family Lawyer",
      metaDesc: "More than 30 years of legal practice dedicated to Family Law. The story of Maria João Nepomuceno, daughter of Dr. Rui Nepomuceno, and her vision for protecting children.",
      overline: "My Story",
      h1: "My Story",
      intro: "I have been a lawyer for more than 30 years.",
      paras1: [
        "I grew up in a family deeply connected to the Law, closely following the path of my father, Dr. Rui Nepomuceno, who was also my pupil-master and my greatest professional reference.",
        "With him I learned that the practice of law is not carried out with legal knowledge alone. It is carried out with rigour, independence, courage and, above all, with respect for the people who entrust us with the most delicate moments of their lives.",
        "Throughout my career, I came to find in Family Law the area that challenges me the most and with which I identify most deeply. Perhaps because I am a mother. Perhaps because I could never accept the ease with which society judges a mother or a father, forgetting that there are no perfect parents.",
        "Sometimes there is no lack of love. There are difficulties, fragilities and the absence of the conditions necessary to provide care. And there are children who need to be truly seen, heard and protected.",
      ],
      quote1: "They are the centre of my work.",
      paras2: [
        "Experience has taught me that, in Family Law, there are no universal formulas nor solutions that can be applied automatically. Each child has their own story. Each family has its own circumstances. And each decision must be considered according to that child's age, emotional bonds, routines, emotional stability and concrete needs.",
        "For many years, I firmly defended alternating residence. I still consider it a positive solution when both parents have been truly present in their children's lives, share the caregiving, are able to communicate with respect and maintain compatible approaches to parenting.",
        "But experience has also shown me that this arrangement does not suit every family.",
      ],
      quote2: "A child is not a suitcase to be carried between two homes every week.",
      paras3: [
        "When there is permanent conflict, profoundly different lifestyles or an inability to cooperate, what should represent balance can turn into a source of instability.",
        "I do not defend mothers against fathers, nor fathers against mothers. I believe every situation must be analysed in depth, without prejudice and without automatic assumptions, seeking to understand who that child is and what they need in order to grow up safely.",
        "I equally believe that parents should not have to face such complex and emotionally demanding proceedings alone. Regulating or modifying parental responsibilities is not a matter of filling in a form. Behind every case there are affections, fears, conflicts and decisions capable of marking an entire life.",
        "That is why I continue to practise law with the same commitment: to listen without judging, to act with firmness and to seek, in every case, a solution that is legally rigorous, but also human.",
      ],
      closing: "Because the best interests of the child cannot be merely words written in the law. They must be truly present in every decision.",
      cta: "Book a consultation",
    },
    legadoPage: {
      metaTitle: "Legacy — Maria João Nepomuceno, Lawyer",
      metaDesc: "A family of jurists from Madeira: Comendador Rui Nepomuceno and his daughters, Maria João and Filipa Nepomuceno — in photographs and memories.",
      overline: "A Family of Jurists",
      h1: "Legacy",
      intro: "Memories of a family deeply connected to the Law and to Madeira's public life — in photographs and stories.",
      items: [
        {
          title: "Maria João with her father, Comendador Rui Nepomuceno",
          desc: "Dr. Rui Nepomuceno — a Madeiran lawyer, politician and historian — was Maria João's pupil-master and her greatest professional reference. From him she learned that law is practised with rigour, independence, courage and respect for people.",
        },
        {
          title: "Comendador Rui Nepomuceno with his daughters, Maria João and Filipa",
          desc: "In the Nepomuceno family, the Law spans generations: Filipa Nepomuceno is currently serving her second term as President of the Deontology Council of the Madeira Bar Association.",
        },
        {
          title: "Maria João with her sister, Filipa Nepomuceno",
          desc: "Between the two sisters, the Law is — beyond a profession — a lifelong bond. Filipa Nepomuceno is serving her second term as President of the Deontology Council of the Madeira Bar Association.",
        },
        {
          title: "The swearing-in of Filipa Nepomuceno's second term",
          desc: "Maria João with her sister at the most recent swearing-in ceremony (Tomada de Posse) of Filipa Nepomuceno as President of the Deontology Council of the Madeira Bar Association — her second consecutive term leading the council.",
        },
        {
          title: "Dra. Maria João Nepomuceno in her robes",
          desc: "At her sister's swearing-in, Maria João wore her lawyer's robes — the same attire in which, for more than 30 years, she has defended families in Madeira's courts.",
        },
        {
          title: "With the Bastonário of the Portuguese Bar Association",
          desc: "Maria João with the Bastonário (President) of the Portuguese Bar Association at the swearing-in of her sister, Filipa Nepomuceno, at the Madeira Regional Council.",
        },
        {
          title: "The Nepomuceno sisters with their father, Comendador Rui Nepomuceno",
          desc: "Maria João and Filipa with their late father — the lawyer, politician and historian who passed on to them the love of the Law and the duty to serve with integrity.",
        },
      ],
    },
    marquee: ["Family Law", "Parental Responsibilities", "Divorce", "Child Support", "Funchal · Madeira"],
    guide: {
      overline: "Free Guide",
      cta: "Receive by email",
      form: {
        name: "Name",
        email: "Email",
        gdpr: "I consent to the processing of my data to receive the guide and be contacted, under the Privacy Policy.",
        submit: "Send me the guide",
        sending: "Sending…",
        success: "Request received. Please check your email.",
        successNote: "While email domain verification is not yet active, you can download the guide directly:",
        download: "Download the guide",
        error: "Something went wrong. Please try again.",
      },
    },
    contact: {
      overline: "Contact",
      heading: "Let's talk about your case.",
      intro: "Fill in the form or reach out directly on WhatsApp. I will reply personally.",
      fields: { name: "Name", email: "Email", phone: "Phone / WhatsApp", lang: "Preferred language", subject: "Subject", message: "Message" },
      langOptions: { pt: "Portuguese", en: "English" },
      gdpr: "I have read and accept the Privacy Policy and consent to the processing of my data for contact purposes.",
      submit: "Send message",
      sending: "Sending…",
      success: "Message sent. Thank you for reaching out.",
      error: "Could not send. Please try again or use WhatsApp.",
      disabledNote: "Note: email delivery will be enabled after domain verification. Your message has been recorded.",
      disclaimer: "This communication does not constitute legal advice, nor does it create an attorney-client relationship until a service agreement is signed.",
    },
    footer: {
      tagline: "Family Law · Funchal, Madeira",
      legacy: "Daughter of Comendador Rui Nepomuceno — lawyer, politician and historian of Madeira. Sister of Filipa Nepomuceno, President of the Deontology Council of the Madeira Bar Association (2nd term).",
      nav: "Navigation",
      contactHeading: "Contact",
      legal: "Legal",
      privacy: "Privacy Policy",
      rights: "All rights reserved.",
    },
    pages: {
      consulta: {
        metaTitle: "Parental Responsibilities — Maria João Nepomuceno, Lawyer",
        metaDesc: "Custody, residence, contact and maintenance — everything shaping a child's life after separation. In person or online.",
        overline: "Children's Law",
        h1: "Parental Responsibilities",
        intro: "Your children's well-being always comes first. I guide parents through every decision that shapes a child's life.",
        paras: [
          "Parental responsibilities concern the important decisions in a child's life — where they live, the time spent with each parent, and their support. These can be agreed between parents or settled with the court's help, always in the child's best interest.",
          "When parents and children live in different places, the consultation can take place remotely, with the same care and confidentiality as an in-person meeting.",
        ],
        bullets: [
          "Custody and children's residence",
          "Contact and holiday arrangements",
          "Child maintenance",
          "Amending and enforcing agreements",
        ],
        cta: "Book a consultation",
      },
      internacional: {
        metaTitle: "International Family Law — Maria João Nepomuceno, Lawyer",
        metaDesc: "Support for families with ties to more than one country, when divorce or children's matters cross borders.",
        overline: "Families Without Borders",
        h1: "International Family Law",
        intro: "More and more families live across countries. I help bring clarity when family matters cross borders.",
        paras: [
          "A divorce or a question about the children takes on new dimensions when a family has ties to more than one country. It matters where and how each issue should be handled.",
          "I accompany these situations with sensitivity and in coordination with professionals in other countries, always focused on protecting the children and the family's peace of mind.",
        ],
        bullets: [
          "Divorce and separation linked to other countries",
          "Children's matters across countries",
          "Recognition of foreign decisions in Portugal",
          "Coordination with lawyers in other jurisdictions",
        ],
        cta: "Discuss my situation",
      },
      vistos: {
        metaTitle: "Visas & Residency in Portugal — Maria João Nepomuceno, Lawyer",
        metaDesc: "Legal guidance for those choosing to live in Portugal and Madeira, with special care for family reunification.",
        overline: "Living in Madeira",
        h1: "Visas & Residency",
        intro: "Starting a new life in Portugal should be simple and secure. I guide the whole journey, from application to settling your family.",
        paras: [
          "Those choosing to live in Portugal and Madeira need support to arrange the visa and residence permit best suited to their situation, along with all the necessary documentation.",
          "As a family lawyer, I give particular attention to family reunification and everything involved in bringing your loved ones to join you, with security and peace of mind.",
        ],
        bullets: [
          "Visas and residence permits",
          "Family reunification",
          "Support settling in Madeira",
          "Close guidance throughout the process",
        ],
        cta: "Start my process",
      },
      divorcio: {
        metaTitle: "Divorce & Separation — Maria João Nepomuceno, Lawyer",
        metaDesc: "Close, discreet guidance through divorce and separation, amicable or contested, in Funchal and online.",
        overline: "A Serene New Chapter",
        h1: "Divorce & Separation",
        intro: "The end of a marriage is one of life's most delicate moments. I guide every step with discretion, firmness and humanity.",
        paras: [
          "A divorce can be handled by mutual agreement — quickly and calmly — or may require the court's intervention when there is no understanding. On either path, my role is to protect your interests and help you close this chapter with dignity.",
          "I handle everything a divorce involves: the division of assets, the family home and, above all, the children's stability. Every family is unique, and every case deserves a strategy of its own.",
        ],
        bullets: [
          "Divorce by mutual agreement",
          "Divorce without the other spouse's consent",
          "Division of assets and the family home",
          "Agreements concerning the children",
        ],
        cta: "Talk about my situation",
      },
      alimentos: {
        metaTitle: "Child & Spousal Support — Maria João Nepomuceno, Lawyer",
        metaDesc: "Setting, adjusting and enforcing child and spousal support. Fair solutions suited to each family.",
        overline: "Providing for Loved Ones",
        h1: "Child & Spousal Support",
        intro: "Providing for your children is both a duty and an act of love. I help find fair amounts — and make sure they are honoured.",
        paras: [
          "Child support ensures children keep the standard of living they deserve, regardless of their parents' separation. The amount should be fair to the one receiving it and manageable for the one paying — and it can be adjusted when life changes.",
          "When support goes unpaid, there are effective means to enforce it. I also handle support between former spouses, always with rigour and sensitivity.",
        ],
        bullets: [
          "Setting the amount of child support",
          "Adjusting support when life changes",
          "Enforcement and recovery of unpaid support",
          "Support for adult children and former spouses",
        ],
        cta: "Book a consultation",
      },
      patrimonio: {
        metaTitle: "Cohabitation & Assets — Maria João Nepomuceno, Lawyer",
        metaDesc: "Legal protection for unmarried couples and family assets: the home, shared property and life agreements.",
        overline: "Protecting What You Built",
        h1: "Cohabitation & Assets",
        intro: "Living together without marrying also builds assets and rights. I help protect what you built together — and each of you.",
        paras: [
          "Cohabitation creates its own rights and duties, often unknown to couples. From the shared home to joint accounts, it matters to know what belongs to whom and how to protect both partners — during life together and if it ends.",
          "I also help organise the family's assets — divisions, gifts and agreements — so that today's decisions bring peace of mind tomorrow.",
        ],
        bullets: [
          "Rights and protection in cohabitation",
          "Division of assets when life together ends",
          "The family home and assets held in one name",
          "Agreements and family asset planning",
        ],
        cta: "Ask for guidance",
      },
    },
    privacy: {
      metaTitle: "Privacy Policy — Maria João Nepomuceno",
      metaDesc: "Privacy policy and processing of personal data.",
      overline: "GDPR",
      h1: "Privacy Policy",
      sections: [
        { title: "Data controller", body: "Maria João Nepomuceno, Lawyer (Bar No. 200-M), with office at Rua Ivens 22, 3.º Esq., Funchal. Contact: mjn.advogada@gmail.com." },
        { title: "Data collected", body: "We collect the data you provide through the contact and guide-request forms: name, email, phone and the content of your message. Contact requests are handled by email and are not stored in a database. Guide requests are recorded to enable delivery and to comply with legal obligations." },
        { title: "Purpose and basis", body: "Data is processed based on your consent and our legitimate interest in responding to your requests, solely for the purposes of contact and providing legal information." },
        { title: "Retention", body: "Data is kept only for as long as necessary for the stated purposes or for the period required by law." },
        { title: "Your rights", body: "You may exercise your rights of access, rectification, erasure, restriction, portability and objection by contacting mjn.advogada@gmail.com." },
        { title: "Traffic analysis", body: "We use a cookieless analytics solution (Plausible), which collects no personal data and uses no tracking identifiers." },
      ],
    },
    admin: {
      title: "Console",
      subtitle: "Content & requests management",
      email: "Email",
      password: "Password",
      login: "Sign in",
      logout: "Sign out",
      loginError: "Invalid credentials.",
      tabs: { content: "Content", leads: "Guide Requests", messages: "Messages", pdf: "Guide PDF" },
      noMessages: "No messages yet.",
      messagesCount: "messages",
      save: "Save changes",
      saved: "Changes saved.",
      heroTitle: "Hero (title lines)",
      heroSub: "Subtitle",
      overline: "Overline",
      areasTitle: "Practice Areas",
      guideTitle: "Guide metadata",
      leadsCount: "requests",
      exportCsv: "Export CSV",
      uploadPdf: "Replace Guide PDF",
      upload: "Upload",
      uploaded: "PDF updated.",
      noLeads: "No requests yet.",
    },
  },
};
